import React, { Component, PropTypes } from 'react';
import BookingLabelValueItem from './BookingLabelValueItem';

export default class BookingDateItem extends Component {
    static propTypes = {
        date: PropTypes.object.isRequired,
        onClick: PropTypes.func,
    }

    render() {
        return (
            <div className="booking-date-item">
                <BookingLabelValueItem label={this.props.date.format(`ddd D MMM YY`)} onClick={this.props.onClick}>
                    {this.props.date.format(`hh:mm a`)}
                </BookingLabelValueItem>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Booking/BookingDateItem.jsx